class HighLightEventDispatcher extends EventTarget {
    
    constructor(){
        super();
        this._eventName = 'update';
        this._highLights = {};
        //limit district highlight to 15
        this.highLightLimits={'system':15};
    }

    get eventName(){
        return this._eventName;
    }

    highlights(){
        return this._highLights;
    }

  
    toggleHighLight(index, value, data = {}){

        if(this.getHighlight(index,value)){
            this.removeHighlight(index,value);
            return false;
        }
        
        this.addHighlight(index,value,data);
        return true;
        
    }


    getHighlight(index,value){
        if(this._highLights[index]){
            if(this._highLights[index][value]){
                return this._highLights[index][value];
            }
        }

        return null;
    }

    getIndex(index,value){
        if(!this._highLights[index]){
            return -1;   
        }
        if(!this._highLights[index][value]){
            return -1
        }
        return this._highLights[index][value].idx;
        
    }

    getHighlightArray(index){

        let highLights = [];

        if(this._highLights[index]){
            for(var key in this._highLights[index]){
                highLights.push({name:key,highLight:this._highLights[index][key].highlight });
            }
        }
    
        return highLights;
    }

    addHighlight(index,value,data = {}){
        //check if a higlight limit is set for the index
        if(this.highLightLimits && this.highLightLimits[index]){
            //check if the index is set
            if(this._highLights[index]){
                //count the number of highlights
                let count = 0;
                for(let key in this._highLights[index]){
                    count++;
                }
                if(count >= this.highLightLimits[index]){
                   
                    return false;
                }
            }
        }

       
        if(!this._highLights[index]){
            this._highLights[index] = {};
        }
        if(!this._highLights[index][value]){
            this._highLights[index][value] = {};
        }
        this._highLights[index][value]['highlight'] = data;
        this._indexHighLights(index);
        this.dispatchHighlightEvent();
        return true;
    }

    _indexHighLights(index){
        if(!this._highLights[index]){
            return;
        }
        let tempArr = [];
        for(let key in this._highLights[index]){
            tempArr.push(this._highLights[index][key]);
        }
        
        tempArr.sort((a,b)=>{
            return a.idx - b.idx;
        });
        for(var i = 0;i<tempArr.length;i++){
            tempArr[i].idx = i;
        }
    }

    removeHighlight(index,value){
        if(this._highLights[index]){
            delete this._highLights[index][value];
            if(Object.keys(this._highLights[index]).length === 0){
                delete this._highLights[index];
            }
        }
        this.dispatchHighlightEvent();
    }
    removeIndex(index){
        if(this._highLights[index]){
            delete this._highLights[index];
        }
        this.dispatchHighlightEvent();
    }

    removeAllHighlights(){
        this._highLights  = {};
        //explicitly delete all highlights
        for(let key in this._highLights){
            delete this._highLights[key];
        }

        this.dispatchHighlightEvent();
    }

    dispatchHighlightEvent(){
        var event = new CustomEvent(this._eventName, {detail:this._highLights} );
        this.dispatchEvent(event);
    }
}

const instance = new HighLightEventDispatcher();
export default instance;